var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Misroute Assignee")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-md-6 form-group row datefilter-css"
  }, [_c('b-form-fieldset', {
    staticClass: "col-md-3 datefilter-input-css"
  }, [_c('b-input-group', [_c('label', [_vm._v("From:")]), _vm._v("  \n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtCFDate),
      expression: "txtCFDate"
    }],
    staticClass: "form-control DateFt-css",
    attrs: {
      "type": "date",
      "lang": "en",
      "name": "from",
      "onkeydown": "return false",
      "not-before": _vm.validDateRangeFrom,
      "not-after": _vm.validDateRangeFrom
    },
    domProps: {
      "value": (_vm.txtCFDate)
    },
    on: {
      "change": _vm.checkToDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtCFDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('b-form-fieldset', {
    staticClass: "col-md-3 datefilter-input-css",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('b-input-group', [_c('label', [_vm._v("To:")]), _vm._v("  \n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtCTDate),
      expression: "txtCTDate"
    }],
    staticClass: "form-control DateFt-css",
    attrs: {
      "lang": "en",
      "type": "date",
      "min": _vm.selectedDtpFromDate,
      "disabled": _vm.txtCFDate == null,
      "name": "to",
      "not-before": _vm.txtCFDate,
      "not-after": _vm.todaysDate
    },
    domProps: {
      "value": (_vm.txtCTDate)
    },
    on: {
      "change": _vm.checkFromDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtCTDate = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "Misroutetab",
    staticStyle: {
      "margin-top": "-65px",
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    class: {
      active: _vm.currentTab == 'Unassigned'
    },
    attrs: {
      "title": _vm.tabTitle('Unassigned', _vm.unAssTabShipCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "Planned-tabs mb-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'WithinSLA'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('WithinSLA')
      }
    }
  }, [_vm._v("Within SLA " + _vm._s("(" + _vm.withinSlaCount + ")"))]), _vm._v(" |\n                                                    "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'SLABreached'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('SLABreached')
      }
    }
  }, [_vm._v("SLA Breached " + _vm._s("(" + _vm.slaBreachedCount + ")") + "\n                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "moreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                                                    ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tabWiseGetAndSearchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Enter AWB's: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBNumbers),
      expression: "AWBNumbers"
    }],
    ref: "textarea",
    staticClass: "col-md-12",
    attrs: {
      "rows": "2",
      "placeholder": "Enter AWB",
      "name": "AWBNumbers",
      "id": "AWBNumbers"
    },
    domProps: {
      "value": (_vm.AWBNumbers)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBNumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.ShipmentType),
      callback: function($$v) {
        _vm.ShipmentType = $$v
      },
      expression: "ShipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Vendors :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.VendorListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.VendorList,
      "selected-option": _vm.VendornameObj,
      "name": "Vendorname",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectVendorName
    },
    model: {
      value: (_vm.Vendorname),
      callback: function($$v) {
        _vm.Vendorname = $$v
      },
      expression: "Vendorname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Suggested SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SuggSVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SuggSVCList,
      "selected-option": _vm.SuggSVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSuggestedSVC
    },
    model: {
      value: (_vm.SuggSVC),
      callback: function($$v) {
        _vm.SuggSVC = $$v
      },
      expression: "SuggSVC"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.MisrouteReason),
      callback: function($$v) {
        _vm.MisrouteReason = $$v
      },
      expression: "MisrouteReason"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-3 buttonCSS"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                                                            Search")]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  Reset")])]) : _vm._e()]), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.MisrouteType),
      callback: function($$v) {
        _vm.MisrouteType = $$v
      },
      expression: "MisrouteType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("City :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CityLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CityList,
      "selected-option": _vm.CityObj,
      "name": "City",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.City),
      callback: function($$v) {
        _vm.City = $$v
      },
      expression: "City"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Zone :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.ZoneLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ZoneList,
      "selected-option": _vm.ZoneObj,
      "name": "Zone",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectZone
    },
    model: {
      value: (_vm.Zone),
      callback: function($$v) {
        _vm.Zone = $$v
      },
      expression: "Zone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SVCList,
      "selected-option": _vm.SVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSVC
    },
    model: {
      value: (_vm.SVC),
      callback: function($$v) {
        _vm.SVC = $$v
      },
      expression: "SVC"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current Pincode :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CurrPincodeListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CurrPincodeList,
      "selected-option": _vm.CurrpincodeObj,
      "name": "Currpincode",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCurrPincode
    },
    model: {
      value: (_vm.Currpincode),
      callback: function($$v) {
        _vm.Currpincode = $$v
      },
      expression: "Currpincode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 buttonCSS1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('span', {
    staticClass: "totalCount-Css1"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))]), _vm._v(" "), (_vm.BulkAssignButton == false) ? _c('button', {
    staticClass: "btn btn-primary linkforspan table-buttons ml-2",
    attrs: {
      "type": "submit",
      "disabled": _vm.AssignButton == false
    },
    on: {
      "click": function($event) {
        return _vm.AssignToChecker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("  Assign\n                                                        ")]) : _vm._e(), _vm._v("     \n                                                        "), (_vm.AssignButton == false && _vm.BulkAssignButton == true) ? _c('button', {
    staticClass: "btn btn-primary linkforspan table-buttons ml-2",
    attrs: {
      "type": "submit",
      "disabled": _vm.BulkAssignButton == false
    },
    on: {
      "click": function($event) {
        return _vm.BulkAssignFun()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("  Bulk Assign\n                                                        ")]) : _vm._e(), _vm._v("     \n                                                        "), (_vm.AssignButton == false && _vm.BulkActionButton == true) ? _c('button', {
    staticClass: "btn btn-primary table-buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.BulkActionButton == false
    },
    on: {
      "click": function($event) {
        return _vm.BulkActionFun()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Bulk Action\n                                                        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.UnassignedColumns,
      "IsDropDown": true,
      "userList": _vm.UserList,
      "showShipmentsList": _vm.showShipmentsList,
      "IsCheckbox": true,
      "IsReload": _vm.IsReload,
      "IsTakeAction": true,
      "Shipmentloader": _vm.Shipmentloader
    },
    on: {
      "showMultiShipPopup": _vm.showMultiShipPopup,
      "takeAction": _vm.takeAction,
      "selectedItemdata": _vm.selectedItemdataEvent,
      "selectUser": _vm.selectedItemdataEvent
    },
    model: {
      value: (_vm.UnassignedTable),
      callback: function($$v) {
        _vm.UnassignedTable = $$v
      },
      expression: "UnassignedTable"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "UnAsspaginate",
    attrs: {
      "page-count": _vm.Unpagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Pending'
    },
    attrs: {
      "title": _vm.tabTitle('Pending', _vm.pendignShipCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "Planned-tabs mb-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'WithinSLA'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('WithinSLA')
      }
    }
  }, [_vm._v("Within SLA " + _vm._s("(" + _vm.withinSlaCount + ")"))]), _vm._v(" |\n                                                    "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'SLABreached'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('SLABreached')
      }
    }
  }, [_vm._v("SLA Breached " + _vm._s("(" + _vm.slaBreachedCount + ")"))])])]), _vm._v(" "), _c('div', {
    staticClass: "moreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                                                    ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tabWiseGetAndSearchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Enter AWB's: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PendingAWBNumbers),
      expression: "PendingAWBNumbers"
    }],
    ref: "textarea",
    staticClass: "col-md-12",
    attrs: {
      "rows": "2",
      "placeholder": "Enter AWB",
      "name": "PendingAWBNumbers",
      "id": "PendingAWBNumbers"
    },
    domProps: {
      "value": (_vm.PendingAWBNumbers)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PendingAWBNumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.PendingShipmentType),
      callback: function($$v) {
        _vm.PendingShipmentType = $$v
      },
      expression: "PendingShipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Vendors :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.VendorListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.VendorList,
      "selected-option": _vm.VendornameObj,
      "name": "Vendorname",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectVendorName
    },
    model: {
      value: (_vm.PendingVendorname),
      callback: function($$v) {
        _vm.PendingVendorname = $$v
      },
      expression: "PendingVendorname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Suggested SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SuggSVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SuggSVCList,
      "selected-option": _vm.SuggSVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSuggestedSVC
    },
    model: {
      value: (_vm.PendingSuggSVC),
      callback: function($$v) {
        _vm.PendingSuggSVC = $$v
      },
      expression: "PendingSuggSVC"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.PendingMisrouteReason),
      callback: function($$v) {
        _vm.PendingMisrouteReason = $$v
      },
      expression: "PendingMisrouteReason"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-3 buttonCSS"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        return _vm.tabWiseGetAndSearchData()
      }
    }
  }), _vm._v("\n                                                            Search")]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  Reset")])]) : _vm._e()]), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.PendingMisrouteType),
      callback: function($$v) {
        _vm.PendingMisrouteType = $$v
      },
      expression: "PendingMisrouteType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("City :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CityLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CityList,
      "selected-option": _vm.CityObj,
      "name": "PendingCity",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.PendingCity),
      callback: function($$v) {
        _vm.PendingCity = $$v
      },
      expression: "PendingCity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Zone :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.ZoneLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ZoneList,
      "selected-option": _vm.ZoneObj,
      "name": "Zone",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectZone
    },
    model: {
      value: (_vm.PendingZone),
      callback: function($$v) {
        _vm.PendingZone = $$v
      },
      expression: "PendingZone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SVCList,
      "selected-option": _vm.SVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSVC
    },
    model: {
      value: (_vm.PendingSVC),
      callback: function($$v) {
        _vm.PendingSVC = $$v
      },
      expression: "PendingSVC"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current Pincode :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CurrPincodeListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CurrPincodeList,
      "selected-option": _vm.CurrpincodeObj,
      "name": "Currpincode",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCurrPincode
    },
    model: {
      value: (_vm.PendingCurrpincode),
      callback: function($$v) {
        _vm.PendingCurrpincode = $$v
      },
      expression: "PendingCurrpincode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 buttonCSS1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row mt-4"
  }, [_c('span', {
    staticClass: "totalCount-Css"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.PendingColumns,
      "showShipmentsList": _vm.showShipmentsList,
      "Shipmentloader": _vm.Shipmentloader
    },
    on: {
      "showMultiShipPopup": _vm.showMultiShipPopup
    },
    model: {
      value: (_vm.PendingTable),
      callback: function($$v) {
        _vm.PendingTable = $$v
      },
      expression: "PendingTable"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "Pendingpaginate",
    attrs: {
      "page-count": _vm.PnPagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Accepted'
    },
    attrs: {
      "title": _vm.tabTitle('Accepted', _vm.acceptedShipCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "Planned-tabs mb-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'WithinSLA'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('WithinSLA')
      }
    }
  }, [_vm._v("Within SLA " + _vm._s("(" + _vm.withinSlaCount + ")"))]), _vm._v(" |\n                                                    "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'SLABreached'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('SLABreached')
      }
    }
  }, [_vm._v("SLA Breached " + _vm._s("(" + _vm.slaBreachedCount + ")"))])])]), _vm._v(" "), _c('div', {
    staticClass: "moreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                                                    ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tabWiseGetAndSearchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Enter AWB's: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccAWBNumbers),
      expression: "AccAWBNumbers"
    }],
    ref: "textarea",
    staticClass: "col-md-12",
    attrs: {
      "rows": "2",
      "placeholder": "Enter AWB",
      "name": "AccAWBNumbers",
      "id": "AccAWBNumbers"
    },
    domProps: {
      "value": (_vm.AccAWBNumbers)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AccAWBNumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.AccShipmentType),
      callback: function($$v) {
        _vm.AccShipmentType = $$v
      },
      expression: "AccShipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Vendors :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.VendorListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.VendorList,
      "selected-option": _vm.VendornameObj,
      "name": "Vendorname",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectVendorName
    },
    model: {
      value: (_vm.AccVendorname),
      callback: function($$v) {
        _vm.AccVendorname = $$v
      },
      expression: "AccVendorname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Suggested SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SuggSVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SuggSVCList,
      "selected-option": _vm.SuggSVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSuggestedSVC
    },
    model: {
      value: (_vm.AccSuggSVC),
      callback: function($$v) {
        _vm.AccSuggSVC = $$v
      },
      expression: "AccSuggSVC"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.AccMisrouteReason),
      callback: function($$v) {
        _vm.AccMisrouteReason = $$v
      },
      expression: "AccMisrouteReason"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-3 buttonCSS"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        return _vm.tabWiseGetAndSearchData()
      }
    }
  }), _vm._v("\n                                                            Search")]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  Reset")])]) : _vm._e()]), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.AccMisrouteType),
      callback: function($$v) {
        _vm.AccMisrouteType = $$v
      },
      expression: "AccMisrouteType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("City :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CityLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CityList,
      "selected-option": _vm.CityObj,
      "name": "AccCity",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.AccCity),
      callback: function($$v) {
        _vm.AccCity = $$v
      },
      expression: "AccCity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Zone :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.ZoneLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ZoneList,
      "selected-option": _vm.ZoneObj,
      "name": "AccZone",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectZone
    },
    model: {
      value: (_vm.AccZone),
      callback: function($$v) {
        _vm.AccZone = $$v
      },
      expression: "AccZone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SVCList,
      "selected-option": _vm.SVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSVC
    },
    model: {
      value: (_vm.AccSVC),
      callback: function($$v) {
        _vm.AccSVC = $$v
      },
      expression: "AccSVC"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current Pincode :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CurrPincodeListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CurrPincodeList,
      "selected-option": _vm.CurrpincodeObj,
      "name": "Currpincode",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCurrPincode
    },
    model: {
      value: (_vm.AccCurrpincode),
      callback: function($$v) {
        _vm.AccCurrpincode = $$v
      },
      expression: "AccCurrpincode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 buttonCSS1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        return _vm.tabWiseGetAndSearchData()
      }
    }
  })]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row mt-4"
  }, [_c('span', {
    staticClass: "totalCount-Css"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.AcceptedColumns,
      "showShipmentsList": _vm.showShipmentsList,
      "Shipmentloader": _vm.Shipmentloader
    },
    on: {
      "showMultiShipPopup": _vm.showMultiShipPopup
    },
    model: {
      value: (_vm.AcceptedTable),
      callback: function($$v) {
        _vm.AcceptedTable = $$v
      },
      expression: "AcceptedTable"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "Accpaginate",
    attrs: {
      "page-count": _vm.accPagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Rejected'
    },
    attrs: {
      "title": _vm.tabTitle('Rejected', _vm.rejectedShipCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "Planned-tabs mb-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'WithinSLA'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('WithinSLA')
      }
    }
  }, [_vm._v("Within SLA " + _vm._s("(" + _vm.withinSlaCount + ")"))]), _vm._v(" |\n                                                    "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'SLABreached'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentScreenValue('SLABreached')
      }
    }
  }, [_vm._v("SLA Breached " + _vm._s("(" + _vm.slaBreachedCount + ")"))])])]), _vm._v(" "), _c('div', {
    staticClass: "moreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                                                    ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tabWiseGetAndSearchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Enter AWB's: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RejAWBNumbers),
      expression: "RejAWBNumbers"
    }],
    ref: "textarea",
    staticClass: "col-md-12",
    attrs: {
      "rows": "2",
      "placeholder": "Enter AWB",
      "name": "RejAWBNumbers",
      "id": "RejAWBNumbers"
    },
    domProps: {
      "value": (_vm.RejAWBNumbers)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RejAWBNumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.RejShipmentType),
      callback: function($$v) {
        _vm.RejShipmentType = $$v
      },
      expression: "RejShipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Vendors :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.VendorListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.VendorList,
      "selected-option": _vm.VendornameObj,
      "name": "Vendorname",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectVendorName
    },
    model: {
      value: (_vm.RejVendorname),
      callback: function($$v) {
        _vm.RejVendorname = $$v
      },
      expression: "RejVendorname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Suggested SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SuggSVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SuggSVCList,
      "selected-option": _vm.SuggSVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSuggestedSVC
    },
    model: {
      value: (_vm.RejSuggSVC),
      callback: function($$v) {
        _vm.RejSuggSVC = $$v
      },
      expression: "RejSuggSVC"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.RejMisrouteReason),
      callback: function($$v) {
        _vm.RejMisrouteReason = $$v
      },
      expression: "RejMisrouteReason"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-3 buttonCSS"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        return _vm.tabWiseGetAndSearchData()
      }
    }
  }), _vm._v("\n                                                            Search")]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  Reset")])]) : _vm._e()]), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.RejMisrouteType),
      callback: function($$v) {
        _vm.RejMisrouteType = $$v
      },
      expression: "RejMisrouteType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("City :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CityLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CityList,
      "selected-option": _vm.CityObj,
      "name": "PendingCity",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.RejCity),
      callback: function($$v) {
        _vm.RejCity = $$v
      },
      expression: "RejCity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Zone :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.ZoneLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ZoneList,
      "selected-option": _vm.ZoneObj,
      "name": "Zone",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectZone
    },
    model: {
      value: (_vm.RejZone),
      callback: function($$v) {
        _vm.RejZone = $$v
      },
      expression: "RejZone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.SVCLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SVCList,
      "selected-option": _vm.SVCObj,
      "name": "SVC",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectSVC
    },
    model: {
      value: (_vm.RejSVC),
      callback: function($$v) {
        _vm.RejSVC = $$v
      },
      expression: "RejSVC"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Current Pincode :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.CurrPincodeListLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CurrPincodeList,
      "selected-option": _vm.CurrpincodeObj,
      "name": "Currpincode",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectCurrPincode
    },
    model: {
      value: (_vm.RejCurrpincode),
      callback: function($$v) {
        _vm.RejCurrpincode = $$v
      },
      expression: "RejCurrpincode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 buttonCSS1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        return _vm.tabWiseGetAndSearchData()
      }
    }
  })]), _vm._v("  \n                                                        "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row mt-4"
  }, [_c('span', {
    staticClass: "totalCount-Css"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.RejectedColumns,
      "showShipmentsList": _vm.showShipmentsList,
      "Shipmentloader": _vm.Shipmentloader
    },
    on: {
      "showMultiShipPopup": _vm.showMultiShipPopup
    },
    model: {
      value: (_vm.RejectedTable),
      callback: function($$v) {
        _vm.RejectedTable = $$v
      },
      expression: "RejectedTable"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "Rejpaginate",
    attrs: {
      "page-count": _vm.RejPagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])], 1)], 1)], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Take Bulk Action",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.BulkActionModel),
      callback: function($$v) {
        _vm.BulkActionModel = $$v
      },
      expression: "BulkActionModel"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.submitLoader
    },
    on: {
      "update:active": function($event) {
        _vm.submitLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bulk Take Action Operations")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBulkActionModel(), _vm.resetFiltersAndGetData()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "padding": "2pt"
    }
  }, [_c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', [_c('center', [_c('div', {
    staticClass: "form-group row col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Take Action :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-left": "45px"
    }
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AcceptReject),
      expression: "AcceptReject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "Accepted1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.AcceptReject, "1")
    },
    on: {
      "click": function($event) {
        return _vm.switchradio()
      },
      "change": function($event) {
        _vm.AcceptReject = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Accepted1"
    }
  }, [_vm._v(" Accept ")])]), _vm._v("  \n                                                          "), _c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AcceptReject),
      expression: "AcceptReject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "Rejected1",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.AcceptReject, "0")
    },
    on: {
      "click": function($event) {
        return _vm.switchradio()
      },
      "change": function($event) {
        _vm.AcceptReject = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Rejected1"
    }
  }, [_vm._v(" Reject ")])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AcceptReject == '1' && _vm.isRTODTO),
      expression: "AcceptReject == '1' && isRTODTO"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group mt-3 mr-3"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-6"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Select Pincode: ")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8 mr-3 mt-1"
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.PincodeList,
      "selected-option": _vm.PincodeListObj,
      "name": "Pincode",
      "placeholder": "Select Pincode"
    },
    on: {
      "select": _vm.selectPincode
    },
    model: {
      value: (_vm.BulkSPincode),
      callback: function($$v) {
        _vm.BulkSPincode = $$v
      },
      expression: "BulkSPincode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AcceptReject == '0'),
      expression: "AcceptReject == '0'"
    }],
    staticClass: "input-group",
    staticStyle: {
      "top": "1em",
      "left": "10px"
    }
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Reason for Rejection:")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectReason),
      expression: "rejectReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('form-1.rejectReason')
    },
    attrs: {
      "id": "rejectReason",
      "name": "rejectReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rejectReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select Rejection Reason --")]), _vm._v(" "), _vm._l((_vm.rejectReasonObj), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.Reason
      }
    }, [_vm._v(_vm._s(reason.Reason))])
  })], 2)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-4"
  }, [(_vm.AcceptReject) ? _c('div', [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitMisrouteRequests()
      }
    }
  }, [_vm._v("Submit")]), _vm._v("     \n                                                        "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelBulkActionReq()
      }
    }
  }, [_vm._v("Cancel")])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsMisrouteReqSE && !_vm.SubmitRequestModel),
      expression: "IsMisrouteReqSE && !SubmitRequestModel"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged,
      "dismissed": _vm.closeBulkActionModel
    }
  }, [((_vm.requestsErrorMsg.length > 0 || _vm.mismatchedTypeShipments.length > 0) && _vm.IsMisrouteReqSE) ? _c('div', [_c('span', {
    staticClass: "SuccCount"
  }, [_vm._v("Success Count : " + _vm._s(_vm.reqSuccessCount))])]) : _vm._e(), _vm._v(" "), (_vm.requestsErrorMsg.length > 0 || _vm.mismatchedTypeShipments.length > 0) ? _c('div', [_c('span', {
    staticClass: "ErrCount"
  }, [_vm._v("Error Count : " + _vm._s(_vm.reqErrorCount))])]) : _vm._e(), _vm._v(" "), (_vm.requestsErrorMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.requestsErrorMsg), function(item) {
    return [_c('span', [_vm._v(_vm._s(item.Shipment) + " :- " + _vm._s(item.message))]), _c('br')]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.mismatchedTypeShipments.length > 0 && _vm.mismatchedTypeError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [
    [_c('span', [_vm._v(_vm._s(_vm.mismatchedTypeError.Shipment) + " :- " + _vm._s(_vm.mismatchedTypeError.message))]), _c('br')]
  ], 2) : _vm._e()])], 1)])])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "4pt"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeBulkActionModel(), _vm.resetFiltersAndGetData()
      }
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Take Bulk Assign Action",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.BulkAssignModel),
      callback: function($$v) {
        _vm.BulkAssignModel = $$v
      },
      expression: "BulkAssignModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bulk Assign Operations")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBulkAssignModel(), _vm.resetFiltersAndGetData()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "padding": "2pt"
    }
  }, [_c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', [_c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "margin": "auto",
      "width": "80%",
      "padding": "10px"
    }
  }, [_c('label', [_vm._v("Select User:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.UserList,
      "selected-option": _vm.UserObj,
      "name": "User",
      "placeholder": "Select User"
    },
    on: {
      "select": _vm.selectUser
    },
    model: {
      value: (_vm.User),
      callback: function($$v) {
        _vm.User = $$v
      },
      expression: "User"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-3",
    staticStyle: {
      "margin-left": "140px"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelBulkAssignReq()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.AssignToChecker()
      }
    }
  }, [_vm._v(" Confirm")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.IsAssignReqSE) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged,
      "dismissed": _vm.closeBulkAssignModel
    }
  }, [(_vm.IsAssignReqSE) ? _c('div', [_c('span', {
    staticClass: "SuccCount"
  }, [_vm._v("Success Count : " + _vm._s(_vm.reqSuccessCount))])]) : _vm._e(), _vm._v(" "), (_vm.mismatchedTypeError) ? _c('div', [_c('span', {
    staticClass: "ErrCount"
  }, [_vm._v("Error Count : " + _vm._s(_vm.reqErrorCount))])]) : _vm._e(), _vm._v(" "), (_vm.mismatchedTypeShipments.length > 0 && _vm.mismatchedTypeError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [
    [_c('span', [_vm._v(_vm._s(_vm.mismatchedTypeError.Shipment) + " :-\n                                                                    " + _vm._s(_vm.mismatchedTypeError.message))])]
  ], 2) : _vm._e()])], 1)]) : _vm._e()])])])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "4pt"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeBulkAssignModel(), _vm.resetFiltersAndGetData()
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Misroute Request Form",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeSubmitRequestModel
    },
    model: {
      value: (_vm.SubmitRequestModel),
      callback: function($$v) {
        _vm.SubmitRequestModel = $$v
      },
      expression: "SubmitRequestModel"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.submitLoader
    },
    on: {
      "update:active": function($event) {
        _vm.submitLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [(_vm.BulkMisrouteinfoArr.length == 0) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Misroute Action Submit Form")]) : _vm._e(), _vm._v(" "), (_vm.BulkMisrouteinfoArr.length > 0) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bulk Misroute Action Submit Form")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeSubmitRequestModel(), _vm.resetFiltersAndGetData()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Accept/Reject Form")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isResetLoad
    },
    on: {
      "update:active": function($event) {
        _vm.isResetLoad = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "padding": "0px",
      "border-right-style": "groove",
      "border-right-width": "2px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Select Shipment Type ")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqShipmentType),
      expression: "ReqShipmentType"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "ReqShipmentType",
      "type": "text",
      "name": "ReqShipmentType",
      "placeholder": "Shipment Type"
    },
    domProps: {
      "value": (_vm.ReqShipmentType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqShipmentType = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ReqShipmentType')),
      expression: "errors.has('form-1.ReqShipmentType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Shipment Type. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Enter AWB No")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqShipmentToShow),
      expression: "ReqShipmentToShow"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReqShipmentToShow')
    },
    attrs: {
      "disabled": "",
      "id": "ReqShipmentToShow",
      "type": "text",
      "name": "ReqShipmentToShow",
      "placeholder": "Enter AWB Number"
    },
    domProps: {
      "value": (_vm.ReqShipmentToShow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqShipmentToShow = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), (_vm.isRTODTO) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Vendor Name")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqVendorName),
      expression: "ReqVendorName"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReqVendorName')
    },
    attrs: {
      "disabled": "",
      "id": "ReqVendorName",
      "type": "text",
      "name": "ReqVendorName",
      "placeholder": "Vendor Name"
    },
    domProps: {
      "value": (_vm.ReqVendorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqVendorName = $event.target.value
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [(_vm.isRTODTO) ? _c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Vendor Address :")]) : _c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Current Address :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqCurrentAddress),
      expression: "ReqCurrentAddress"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "ReqCurrentAddress",
      "type": "text",
      "name": "ReqCurrentAddress",
      "placeholder": "Enter Address"
    },
    domProps: {
      "value": (_vm.ReqCurrentAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqCurrentAddress = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [(!_vm.isRTODTO) ? _c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Current Pincode :")]) : _c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("RTO/DTO Pincode :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqCurrentPincode),
      expression: "ReqCurrentPincode"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "ReqCurrentPincode",
      "type": "text",
      "name": "ReqCurrentPincode",
      "placeholder": "Enter Pincode"
    },
    domProps: {
      "value": (_vm.ReqCurrentPincode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqCurrentPincode = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Current Destination SVC:")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqCurrentDestSVC),
      expression: "ReqCurrentDestSVC"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "ReqCurrentDestSVC",
      "type": "text",
      "name": "ReqCurrentDestSVC",
      "placeholder": "Enter SVC"
    },
    domProps: {
      "value": (_vm.ReqCurrentDestSVC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqCurrentDestSVC = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Reason for Misroute")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqReason),
      expression: "ReqReason"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReqReason')
    },
    attrs: {
      "disabled": "",
      "id": "ReqReason",
      "type": "text",
      "name": "ReqReason"
    },
    domProps: {
      "value": (_vm.ReqReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqReason = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ReqsuggPincode),
      expression: "ReqsuggPincode"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Suggested Pincode")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqsuggPincode),
      expression: "ReqsuggPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ("'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'"),
      expression: "`'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReqsuggPincode')
    },
    attrs: {
      "disabled": "",
      "id": "ReqsuggPincode",
      "type": "text",
      "name": "ReqsuggPincode"
    },
    domProps: {
      "value": (_vm.ReqsuggPincode)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqsuggPincode = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Suggested SVC")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqsuggSVC),
      expression: "ReqsuggSVC"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReqsuggSVC')
    },
    attrs: {
      "disabled": "",
      "id": "ReqsuggSVC",
      "type": "text",
      "name": "ReqsuggSVC"
    },
    domProps: {
      "value": (_vm.ReqsuggSVC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqsuggSVC = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Take Action")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "Accepted",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.selected, "1")
    },
    on: {
      "click": _vm.selectedOption,
      "change": function($event) {
        _vm.selected = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Accepted"
    }
  }, [_vm._v(" Accept ")])]), _vm._v("  \n                                                "), _c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "Rejected",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.selected, "0")
    },
    on: {
      "click": _vm.selectedOption,
      "change": function($event) {
        _vm.selected = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Rejected"
    }
  }, [_vm._v(" Reject ")])])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Actual Pincode")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ActualPincode),
      expression: "ActualPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.MarkShipmentStatus == 'XBU00260' ? 'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'))),
      expression: "`${MarkShipmentStatus == 'XBU00260' ? 'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ActualPincode')
    },
    attrs: {
      "id": "ActualPincode",
      "type": "text",
      "name": "ActualPincode",
      "placeholder": "Enter correct Pincode"
    },
    domProps: {
      "value": (_vm.ActualPincode)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "change": _vm.getPincodeWiseHubForReq,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ActualPincode = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ActualPincode')),
      expression: "errors.has('ActualPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Correct Pincode.")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Actual Destination SVC")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6",
    attrs: {
      "right": _vm.SVCLoader
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ActualDestSVC),
      expression: "ActualDestSVC"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ActualDestSVC')
    },
    attrs: {
      "id": "ActualDestSVC",
      "type": "text",
      "name": "ActualDestSVC",
      "placeholder": "Enter SVC name"
    },
    domProps: {
      "value": (_vm.ActualDestSVC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ActualDestSVC = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '0'),
      expression: "selected == '0'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Reason for Rejection")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectionReason),
      expression: "rejectionReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('form-1.rejectionReason')
    },
    attrs: {
      "id": "rejectionReason",
      "name": "rejectionReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rejectionReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select Rejection Reason --")]), _vm._v(" "), _vm._l((_vm.rejectReasonObj), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.Reason
      }
    }, [_vm._v(_vm._s(reason.Reason))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitMisrouteRequests()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.cancelReq()
      }
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "padding": "0px",
      "border-left-style": "groove",
      "border-left-width": "2px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-5"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Enter Address:")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('b-input-group', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MapAddress),
      expression: "MapAddress"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('MapAddress')
    },
    attrs: {
      "id": "MapAddress",
      "type": "text",
      "name": "MapAddress",
      "placeholder": "Enter Address"
    },
    domProps: {
      "value": (_vm.MapAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MapAddress = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), (!_vm.MapAddress) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "width": "450",
      "height": "400",
      "loading": "lazy",
      "allowfullscreen": "",
      "referrerpolicy": "no-referrer-when-downgrade",
      "src": _vm.MapUrl + _vm.defaultAddress
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.MapAddress) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "width": "450",
      "height": "400",
      "loading": "lazy",
      "allowfullscreen": "",
      "referrerpolicy": "no-referrer-when-downgrade",
      "src": _vm.MapUrl + _vm.MapAddress
    }
  })]) : _vm._e()])], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsMisrouteReqSE && !_vm.BulkActionModel),
      expression: "IsMisrouteReqSE && !BulkActionModel"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged,
      "dismissed": _vm.closeSubmitRequestModel
    }
  }, [((_vm.requestsErrorMsg.length > 0 || _vm.mismatchedTypeShipments.length > 0) && _vm.IsMisrouteReqSE) ? _c('div', [_c('span', {
    staticClass: "SuccCount"
  }, [_vm._v("Success Count : " + _vm._s(_vm.reqSuccessCount))])]) : _vm._e(), _vm._v(" "), (_vm.requestsErrorMsg.length > 0 || _vm.mismatchedTypeShipments.length > 0) ? _c('div', [_c('span', {
    staticClass: "ErrCount"
  }, [_vm._v("Error Count : " + _vm._s(_vm.reqErrorCount))])]) : _vm._e(), _vm._v(" "), (_vm.requestsErrorMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.requestsErrorMsg), function(item) {
    return [_c('span', [_vm._v(_vm._s(item.Shipment) + " :- " + _vm._s(item.message))]), _c('br')]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.mismatchedTypeShipments.length > 0 && _vm.mismatchedTypeError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [
    [_c('span', [_vm._v(_vm._s(_vm.mismatchedTypeError.Shipment) + " :- " + _vm._s(_vm.mismatchedTypeError.message))]), _c('br')]
  ], 2) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeSubmitRequestModel(), _vm.resetFiltersAndGetData()
      }
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Take Bulk Action",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.sameReqShipModel),
      callback: function($$v) {
        _vm.sameReqShipModel = $$v
      },
      expression: "sameReqShipModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Same Request Shipments List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.CloseMoreShipmentModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "padding": "2pt"
    }
  }, [_c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.MultiShipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.MultiShipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('load-table-template', {
    attrs: {
      "columns": _vm.moreShipmentsColumns,
      "showShipmentsList": _vm.sameVendorShipList
    }
  })], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "4pt"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.CloseMoreShipmentModel
    }
  }, [_vm._v("Close")])])], 1)])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7775f0c4","hasScoped":false}!./src/views/components/MisrouteRequestAssignee/MisrouteRequestAssignee.component.html
// module id = 1459
// module chunks = 1